import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  data: null,
  isLoading: false,
  error: null,
  credentials: {
    data: null,
    isLoading: true,
    error: null,
  },
  wallet: {
    data: null,
    isLoading: false,
    error: null,
  },
  recoverPassword: {
    isLoading: false,
    error: null,
  },
  changePassword: {
    message: null,
    isLoading: false,
    error: null,
  },
}

const user = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.data = action.payload.data
      state.isLoading = action.payload.isLoading
      state.error = action.payload.error
    },
    setCredentials: (state, action) => {
      state.credentials.data = action.payload.data
      state.credentials.isLoading = action.payload.isLoading
      state.credentials.error = action.payload.error
    },
    setWallet: (state, action) => {
      state.wallet.data = action.payload.data
      state.wallet.isLoading = action.payload.isLoading
      state.wallet.error = action.payload.error
    },
    setRecoverPassword: (state, action) => {
      state.recoverPassword.isLoading = action.payload.isLoading
      state.recoverPassword.error = action.payload.error
      state.recoverPassword.success = action.payload.success
    },
    setChangePassword: (state, action) => {
      state.changePassword.message = action.payload.message
      state.changePassword.isLoading = action.payload.isLoading
      state.changePassword.error = action.payload.error
    },
    resetUser: () => initialState,
  },
})

export const {
  setUser,
  setRecoverPassword,
  setCredentials,
  setWallet,
  setChangePassword,
  resetUser,
} = user.actions
export default user.reducer
